/** Session storage key of the route to restore once the OIDC callback completes */
export const AUTH_RETURN_TO_KEY = "auth_return_to";
